// @ts-nocheck
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

interface SeriesData {
  name: string;
  data: number[];
}

const exportToExcel = async (
  title: any,
  bins: string[],
  receivedChecks: any,
  labelsOrb: string[][],
  seriesBar: SeriesData[][],
  ofdList: any,
  countGroup: any = {},
  fileName: string = "Отчет.xlsx",
): Promise<void> => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Отчет лист 1");
  const worksheet2 = workbook.addWorksheet("Отчет лист 2");

  // Заголовок первого листа
  worksheet.mergeCells("A1:G1");
  const titleCell = worksheet.getCell("A1");
  titleCell.value = title;
  titleCell.alignment = { horizontal: "center", vertical: "middle" };
  titleCell.font = { bold: true, size: 14 };

  // Шапка таблицы первого листа
  const headerRow = [
    "№",
    "Название ОФД (BIN)",
    "Полученные чеки от ОФД",
    "Название принимающей системы",
    "Общее количество отправленных чеков",
    "Из них успешно отправленные чеки",
    "Из них ошибочные чеки",
  ];
  const header = worksheet.addRow(headerRow);

  header.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Данные первого листа
  let rowIndex = 3;
  bins.forEach((bin, index) => {
    const systems = labelsOrb?.[index] ?? [];
    const received = receivedChecks?.[bin] ?? 0;

    const startRow = rowIndex;
    systems.forEach((system, systemIndex) => {
      const totalCount: number = seriesBar[index]?.[0]?.data[systemIndex] ?? 0;
      const errorCount: number = seriesBar[index]?.[1]?.data[systemIndex] ?? 0;
      const sentCount: number = totalCount - errorCount;

      const row = worksheet.addRow([
        "", // Номер (заполнится ниже при объединении)
        "", // BIN (заполнится ниже при объединении)
        "", // Полученные чеки (заполнится ниже при объединении)
        system, // Название принимающей системы
        totalCount, // Общее количество отправленных чеков
        sentCount, // Успешные чеки
        errorCount, // Ошибочные чеки
      ]);

      row.eachCell((cell) => {
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      rowIndex++;
    });

    // Объединение ячеек для BIN, номера строки и полученных чеков
    if (systems.length > 1) {
      worksheet.mergeCells(`A${startRow}:A${rowIndex - 1}`);
      worksheet.mergeCells(`B${startRow}:B${rowIndex - 1}`);
      worksheet.mergeCells(`C${startRow}:C${rowIndex - 1}`);
    }
    worksheet.getCell(`A${startRow}`).value = index + 1;
    worksheet.getCell(`B${startRow}`).value = ofdList[bin];
    worksheet.getCell(`C${startRow}`).value = received;
  });

  // Итоговая строка первого листа
  const totalReceived = bins.reduce((sum, bin) => sum + (receivedChecks?.[bin] ?? 0), 0);
  const totalSent = seriesBar.reduce((sum, binSeries) => sum + (binSeries[0]?.data.reduce((acc, val) => acc + val, 0) ?? 0), 0);
  const totalError = seriesBar.reduce((sum, binSeries) => sum + (binSeries[1]?.data.reduce((acc, val) => acc + val, 0) ?? 0), 0);
  const totalSuccess = totalSent - totalError;

  const totalRow = worksheet.addRow(["", "Итого", totalReceived, "", totalSent, totalSuccess, totalError]);
  totalRow.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };
  });

  // Установка ширины колонок первого листа
  worksheet.columns = [
    { width: 5 },
    { width: 30 },
    { width: 35 },
    { width: 35 },
    { width: 45 },
    { width: 35 },
    { width: 35 },
  ];

  // Заголовок второго листа
  worksheet2.mergeCells("A1:B1");
  const titleCell2 = worksheet2.getCell("A1");
  titleCell2.value = title;
  titleCell2.alignment = { horizontal: "center", vertical: "middle" };
  titleCell2.font = { bold: true, size: 14 };

  // Шапка таблицы второго листа
  const headerRow2 = ["Название принимающей системы", "Количество фактически отправленных чеков"];
  const header2 = worksheet2.addRow(headerRow2);

  header2.eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Данные второго листа
  let rowIndex2 = 3;
  console.log('countGroup in export:', countGroup);
  
  if (countGroup && Object.keys(countGroup).length > 0) {
    Object.entries(countGroup).forEach(([name, count], index) => {
      console.log('Processing countGroup entry:', name, count);
      const row = worksheet2.addRow([name, count]);
      row.eachCell((cell) => {
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
      rowIndex2++;
    });

    // Итоговая строка второго листа
    const totalCount = Object.values(countGroup).reduce((sum: number, count: any) => sum + Number(count), 0);
    const totalRow2 = worksheet2.addRow(["Итого", totalCount]);
    totalRow2.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };
    });
  } else {
    // Если нет данных, добавляем сообщение
    const noDataRow = worksheet2.addRow(["Нет данных", ""]);
    noDataRow.eachCell((cell) => {
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  }

  // Установка ширины колонок второго листа
  worksheet2.columns = [
    { width: 60 },
    { width: 60 },
  ];

  // Генерация и скачивание файла
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), fileName);
};

export default exportToExcel;
